import { z } from 'zod'

const ASSETS_URL = import.meta.env.VITE_ASSETS_URL

export const AssetPathEnum = z.enum([
  'chitown-avatar/avatar',
  'chitown-building',
  'chitown-images/groups',
  'chitown-images/checklist',
  'chitown-images/checklist-attachments',
  'chitown-images/neighbourhood',
  'chitown-images/training',
  'chitown-images/notification',
  'chitown-default',
  'chitown-images/booking',
  'chitown-avatar/guest-avatar',
  'vehicle-images',
  'reservation_agreements',
  'loyalty_evidence',
  'recordings',
  'inspection_photos',
  'inspection_attachments',
  'email-attachments',
  'vendor-coi',
  'market-images',
])

export type AssetPathType = z.infer<typeof AssetPathEnum>

const prepareFileName = (file: string) => file.split('/').pop()

export const getAssetLink = ({
  path,
  file,
  fallback,
  localFallback,
}: {
  path: AssetPathType
  file?: string
  fallback?: {
    path?: AssetPathType
    file: string
  }
  localFallback?: string
}) => {
  if (file) {
    return `${ASSETS_URL}/${path}/${prepareFileName(file)}`
  } else if (localFallback) {
    return localFallback
  } else if (fallback) {
    const pathString = fallback.path ?? path
    return `${ASSETS_URL}/${pathString}/${prepareFileName(fallback.file)}`
  }

  return ''
}
